import React, {useContext, useMemo} from 'react';
import {OrdinalColumn} from "./ReactTable";
import {ButtonLink, PageHeader} from "./Components";
import AddEditUser from "./modals/AddEditUser";
import DeleteUser from "./modals/DeleteUser";
import ResetUserPassword from "./modals/ResetUserPassword";
import {RouteComponentProps} from "react-router-dom";
import type {UserAdminInfo} from "../services/API";
import {DataAPI} from "../services/API";
import {Helmet} from "react-helmet";
import ReactQueryTable from "./ReactQueryTable";
import {SessionContext} from "./SessionContext";

const UsersTab = (props: RouteComponentProps) => {

  const ctx = useContext(SessionContext);

  const columns = useMemo(()=>[
      OrdinalColumn,
      { Header: 'Login', accessor: 'username' },
      { Header: 'Imię', accessor: 'firstName' },
      { Header: 'Nazwisko', accessor: 'lastName' },
      { Header: 'E-mail', accessor: 'email' },
      { Header: 'Administrator',
        id: 'admin',
        Cell: ({ row }) => {
          const uai: UserAdminInfo = row.original;
          return uai.admin ? <i className="fas fa-check"/> : null;
        }, disableSortBy: true
      },
      { Header: 'Akcje',
        id: 'actions',
        Cell: ({ row }) => {
          const uai: UserAdminInfo = row.original;
          return <div className="actions action-icons">
            <ButtonLink size="sm" variant="link" to={AddEditUser.buildUrl(uai.id)} withBackground={true} className="action-icon-btn action-edit">
              <i className="fas fa-pen"/>
              <span>Edytuj</span>
            </ButtonLink>
            <ButtonLink size="sm" variant="link" to={ResetUserPassword.buildUrl(uai.id)} withBackground={true} className="action-icon-btn">
              <i className="fas fa-key"/>
              <span>Resetuj hasło</span>
            </ButtonLink>
            <ButtonLink size="sm" variant="link" to={DeleteUser.buildUrl(uai.id)} withBackground={true} className="action-icon-btn action-delete">
              <i className="fas fa-trash"/>
              <span>Usuń</span>
            </ButtonLink>
          </div>
        }, disableSortBy: true
      }
    ], []);

    //wiążąco sprawdza to serwer, tu chodzi o to, żeby nie pokazywać pustej tabeli
    if (!ctx.user.admin) return <p>Brak uprawnień</p>;

    return <>
      <Helmet>
        <title>Użytkownicy</title>
      </Helmet>
      <PageHeader>
        <ButtonLink variant="success" to={AddEditUser.buildUrl('new')} withBackground={true}>
          <i className="fas fa-plus"/> Dodaj użytkownika
        </ButtonLink>
      </PageHeader>
      <ReactQueryTable type="user" queryKey="user-list" listenType="user" columns={columns} queryFunction={DataAPI.getUserList}/>
    </>;
}

UsersTab.url = '/users';

export default UsersTab;
